module.exports = __webpack_public_path__ + "static/img/cloud.a30f4829.png";